export default __webpack_public_path__ + "static/cover-fcfa6a6dcc6ce9c6ff072af6736b444a.png";